<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
            <a-input :disabled="params.isShow" placeholder="请输入员工姓名" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入员工姓名' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="员工编号">
            <a-input :disabled="params.isShow" placeholder="请输入员工编号" v-decorator="[
          'code',
          {initialValue:data.code,rules: [{ required: false, message: '请输入员工编号' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input :disabled="params.isShow" placeholder="请输入联系电话" v-decorator="[
          'telephone',
          {initialValue:data.telephone,rules: [{ required: true, message: '请输入联系电话' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销售组织">
            <a-select placeholder="请选择销售组织" @change="orgChange" :options="this.organizationOptions" v-decorator="['organizationId',{initialValue:data.organizationId,rules: [{ required: false, message: '请选择销售组织'}]}]"></a-select>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
            <a-select placeholder="请选择部门" :options="this.departmentOptions" v-decorator="['departmentId',{initialValue:data.departmentId,rules: [{ required: false, message: '请选择部门'}]}]"></a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  name: "",
  code: "",
  telephone: "",
  organizationId: undefined,
  departmentId: undefined,
  isActive: 1
};
export default {
  name: "hp-manager-page-Employee-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      departmentOptions: [],
      organizationOptions: []
    };
  },

  async mounted() {
    if (this.params.id) {
      // this.data = Object.assign(this.params,defaultData)
      this.getDetailEmployee();
    } else {
      this.data = exzends(defaultData);
    }
    this.getOrganizationOptions();
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getOrganizationOptions() {
      let orgList = await api.GetOrganizationSelect();
      if (orgList) {
        orgList.forEach(a => {
          this.organizationOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },
    async orgChange(value) {
      this.departmentOptions = [];
      await this.getDepartmentOptions(value);
      this.form.resetFields(["departmentId"]);
    },
    async getDepartmentOptions(orgId) {
      let departmentList = await api.GetDepartmentSelect({ orgId: orgId });
      if (departmentList) {
        departmentList.forEach(a => {
          this.departmentOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },
    async getDetailEmployee() {
      this.loading = true;
      let result = await api.GetEmployee({ employeeId: this.params.id });
      if (result) {
        this.data = result;
        this.data.organizationId =
          this.data.organizationId != null
            ? this.data.organizationId + ""
            : undefined;
        this.data.departmentId =
          this.data.departmentId != null
            ? this.data.departmentId + ""
            : undefined;
        if (this.data.organizationId != null) {
          await this.getDepartmentOptions(this.data.organizationId);
        }
      }
      this.loading = false;
    },
    async submitHandler() {
      await api.AddOrUpdateEmployee(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        code: value.code,
        telephone: value.telephone,
        organizationId: parseInt(value.organizationId),
        departmentId: parseInt(value.departmentId)
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.AddOrUpdateEmployee(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddOrUpdateEmployee(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Employee/Add.vue